/*
 * Translations for the PUBLIC (logged-out) pages. Hebrew ('he') is the PRIMARY source and the
 * fallback — every key MUST have a Hebrew value. English ('en') is an added option; a missing 'en'
 * key resolves to Hebrew via the provider (never a raw key).
 *
 * Keys are grouped by area via a dotted prefix (nav / directory / search / business / booking /
 * manage / my / common). Weekday/month arrays are stored under a single key as an array; the date
 * helper in I18nContext handles most date formatting via toLocaleDateString, so these arrays are
 * only used where the UI needs custom short chip labels.
 */

export const translations = {
    he: {
        // ── nav (PublicShell) ──
        'nav.discover': 'גילוי עסקים',
        'nav.my': 'ההזמנות שלי',
        'nav.login': 'התחברות',
        'nav.langLabel': 'שפה',

        // ── common ──
        'common.loading': 'טוען…',
        'common.back_to_discovery': 'חזרה לגילוי מסעדות',
        'common.today': 'היום',
        'common.tomorrow': 'מחר',

        // ── directory (BusinessDirectory) ──
        'directory.brand': 'HOPpA',
        'directory.login': 'התחברות',
        'directory.hero_title': 'גלו עסקים',
        'directory.hero_sub': 'כל העסקים במקום אחד — הזמינו מקום בכמה קליקים.',
        'directory.all_businesses': 'כל העסקים',
        'directory.filter_hint': 'סננו לפי קטגוריה או חפשו לפי שם ועיר.',
        'directory.category_group': 'קטגוריה',
        'directory.all': 'הכל',
        'directory.count_found': '{count} עסקים נמצאו',
        'directory.clear_filter': 'ניקוי סינון',
        'directory.loading': 'טוען…',
        'directory.error_title': 'לא ניתן לטעון עסקים כרגע',
        'directory.error_sub': 'נסו לרענן את הדף בעוד רגע.',
        'directory.empty_title': 'לא נמצאו עסקים',
        'directory.empty_sub': 'נסו לשנות את מונחי החיפוש או לנקות את הסינון.',
        'directory.boosted': 'מקודם',
        'directory.boosted_aria': 'עסק מקודם',
        'directory.card_cta': 'קבעו מקום',

        // ── search (DiscoverSearch) ──
        'search.all_cities': 'כל הערים',
        'search.pick_city': 'בחרו עיר',
        'search.city_dialog_aria': 'בחירת עיר',
        'search.city_close': 'סגירה',
        'search.city_empty': 'אין ערים זמינות כרגע — חיפוש בכל הערים.',
        'search.mode_group': 'סוג חיפוש',
        'search.mode_book': 'הזמנת מקום',
        'search.mode_available': 'על בסיס מקום פנוי',
        'search.time_aria': 'שעה',
        'search.date_aria': 'תאריך',
        'search.party_aria': 'מספר סועדים',
        'search.party_one': '1 איש',
        'search.party_many': '{count} אנשים',
        'search.submit': 'מצאו לי מקום',
        'search.day_sunday': 'יום ראשון',
        'search.day_monday': 'יום שני',
        'search.day_tuesday': 'יום שלישי',
        'search.day_wednesday': 'יום רביעי',
        'search.day_thursday': 'יום חמישי',
        'search.day_friday': 'יום שישי',
        'search.day_saturday': 'יום שבת',

        // ── business (PublicBusinessPage) ──
        'business.loading': 'טוען…',
        'business.not_found': 'העסק לא נמצא.',
        'business.back': 'חזרה למסעדות',
        'business.gallery_aria': 'גלריית תמונות',
        'business.image_alt': 'תמונה',
        'business.booking_aria': 'הזמנת שולחן',
        'business.booking_title': 'הזמנת שולחן',
        'business.booking_sub': 'מלאו את הפרטים לפי הסדר. שדות חובה מסומנים.',
        'business.required': 'חובה',
        'business.optional': '(אופציונלי)',
        'business.phone_label': 'טלפון',
        'business.phone_placeholder': '05x-000-0000',
        'business.phone_invalid': 'מספר טלפון לא תקין',
        'business.name_label': 'שם מלא',
        'business.name_placeholder': 'השם שלכם',
        'business.party_label': 'מספר סועדים',
        'business.diner_one': 'סועד',
        'business.diner_many': 'סועדים',
        'business.dec_aria': 'פחות',
        'business.inc_aria': 'עוד',
        'business.date_label': 'תאריך',
        'business.avail_label': 'זמינות ואזור ישיבה',
        'business.checking_avail': 'בודקים זמינות…',
        'business.oversized_title': 'לקבוצה בגודל זה — התקשרו להזמנה',
        'business.oversized_sub_phone': 'קבוצה בגודל זה אינה זמינה להזמנה אונליין. נשמח לארח אתכם — התקשרו אלינו ונסדר לכם מקום.',
        'business.oversized_sub_nophone': 'צרו קשר עם העסק להזמנה לקבוצה גדולה.',
        'business.avail_found': 'מצאנו מספר מקומות פנויים עבורך',
        'business.avail_found_sub': 'ל{date}{time} עבור {party} אנשים',
        'business.avail_around': ' בסביבות {time}',
        'business.instant_confirm': 'אישור מיידי',
        'business.closed': 'סגור',
        'business.no_hours_today': 'אין שעות פעילות ביום זה — בחרו תאריך אחר.',
        'business.no_avail_today': 'אין זמינות ביום זה — נסו תאריך או מספר סועדים אחר.',
        'business.notes_label': 'הערות',
        'business.marketing_consent': 'אשמח לקבל עדכונים ומבצעים מהעסק (לא חובה)',
        'business.notes_placeholder': 'אלרגיות, בקשה מיוחדת, יום הולדת…',
        'business.summary_diners': 'סועדים',
        'business.submitting': 'שולח…',
        'business.submit': 'אישור הזמנה',
        'business.hint_phone': 'הזינו טלפון תקין כדי להמשיך',
        'business.hint_name': 'הוסיפו שם מלא',
        'business.hint_slot_area': 'בחרו שעה ואזור פנויים',
        'business.hint_slot': 'בחרו שעה',
        'business.success_title': 'ההזמנה התקבלה!',
        'business.success_sub': 'ההזמנה נשלחה למסעדה ותופיע אצלם במערכת. ניצור קשר לאישור סופי.',
        'business.manage_prompt': 'לצפייה או ביטול ההזמנה:',
        'business.manage_link': 'ניהול ההזמנה',
        'business.another_booking': 'הזמנה נוספת',
        'business.about_aria': 'אודות',
        'business.about_title': 'אודות',
        'business.menu_aria': 'תפריט',
        'business.menu_title': 'תפריט',
        'business.hours_aria': 'שעות פעילות',
        'business.hours_title': 'שעות פעילות',
        'business.hours_today_suffix': ' · היום',
        'business.location_aria': 'מיקום',
        'business.location_title': 'מיקום',
        'business.rate_limited': 'כבר קיימת הזמנה דומה או שבוצעו יותר מדי נסיונות. נסו מאוחר יותר.',
        'business.booking_failed': 'ההזמנה נכשלה — ייתכן שהשעה קרובה מדי לסגירה או שהקבוצה גדולה — נסו שעה אחרת או התקשרו.',

        // ── manage (ManageReservation) ──
        'manage.loading': 'טוען…',
        'manage.invalid_title': 'הקישור אינו תקין',
        'manage.invalid_sub': 'הקישור אינו תקין או שההזמנה לא נמצאה.',
        'manage.default_biz': 'ההזמנה שלך',
        'manage.title': 'ההזמנה שלך',
        'manage.status_confirmed': 'מאושרת',
        'manage.status_cancelled': 'בוטלה',
        'manage.diners': 'סועדים',
        'manage.cancelled_note': 'ההזמנה בוטלה.',
        'manage.confirm_cancel': 'לבטל את ההזמנה? לא ניתן לשחזר פעולה זו.',
        'manage.cancel_failed': 'ביטול ההזמנה נכשל. נסו שוב או צרו קשר עם העסק.',
        'manage.cancelling': 'מבטל…',
        'manage.cancel_btn': 'ביטול הזמנה',
        'manage.reschedule_note': 'לשינוי מועד — צרו קשר עם העסק.',
        'manage.to_business_page': 'לעמוד העסק',

        // ── my (MyReservations) ──
        'my.status_arrived': 'הגעת',
        'my.status_seated': 'בישיבה',
        'my.status_confirmed': 'מאושרת',
        'my.title': 'ההזמנות שלי',
        'my.phone_sub': 'הזינו את מספר הטלפון שאיתו הזמנתם — נשלח לכם קוד חד-פעמי ב-SMS.',
        'my.phone_placeholder': '050-0000000',
        'my.phone_aria': 'מספר טלפון',
        'my.phone_invalid': 'הזינו מספר טלפון תקין',
        'my.send_failed': 'לא הצלחנו לשלוח קוד, נסו שוב',
        'my.sending': 'שולח…',
        'my.send_code': 'שליחת קוד',
        'my.code_title': 'הזינו את הקוד',
        'my.code_sub': 'שלחנו קוד ל-{phone} (אם קיימות הזמנות במספר זה).',
        'my.code_placeholder': '●●●●●●',
        'my.code_aria': 'קוד חד-פעמי',
        'my.code_missing': 'הזינו את הקוד שקיבלתם',
        'my.code_invalid': 'קוד שגוי או שפג תוקפו',
        'my.checking': 'בודק…',
        'my.view_reservations': 'צפייה בהזמנות',
        'my.change_number': 'החלפת מספר',
        'my.future_title': 'ההזמנות העתידיות שלך',
        'my.none': 'אין לך הזמנות עתידיות.',
        'my.discover': 'גילוי עסקים',
        'my.default_biz': 'העסק',
        'my.diners': 'סועדים',
        'my.confirm_cancel': 'לבטל את ההזמנה? לא ניתן לשחזר פעולה זו.',
        'my.cancel_failed': 'ביטול ההזמנה נכשל. נסו שוב או צרו קשר עם העסק.',
        'my.cancelling': 'מבטל…',
        'my.cancel': 'ביטול',
        'my.details': 'פרטים',

        // ── home (MarketingHome / /welcome) ──
        'home.brand_aria': 'HOPpA',
        'home.nav.restaurants': 'מסעדות',
        'home.nav.how': 'איך זה עובד',
        'home.nav.pricing': 'מחירים',
        'home.nav.faq': 'שאלות',
        'home.search_placeholder': 'חיפוש מסעדה, מטבח או עיר…',
        'home.search_aria': 'חיפוש',
        'home.menu_aria': 'תפריט',
        'home.login': 'התחברות',
        'home.register': 'הרשמה',

        // hero
        'home.hero_title': 'קבעו מקום במסעדות הכי מבוקשות',
        'home.hero_sub': 'גלו מסעדות פנויות היום והזמינו שולחן בכמה קליקים.',

        // mosaic cards (name/cat/area kept as sample data; only labels translated)
        'home.book_at': 'הזמנת מקום ב{name}',
        'home.badge_today': 'פנוי היום',

        // promo (מומלץ)
        'home.promo_tag': 'מומלץ',
        'home.promo_title': 'ערב שישי בעיר?',
        'home.promo_text': 'המסעדות הכי מבוקשות מתמלאות מהר — תפסו שולחן עכשיו.',
        'home.promo_cta': 'גלו הכל',

        // filter pills
        'home.filter_aria': 'סינון',
        'home.pill.all': 'הכל',
        'home.pill.chef': 'מסעדות שף',
        'home.pill.grill': 'בשרים · על האש',
        'home.pill.fish': 'דגים ופירות ים',
        'home.pill.italian': 'איטלקי',
        'home.pill.asian': 'אסייתי',
        'home.pill.mediterranean': 'ים תיכוני',
        'home.pill.vegan': 'טבעוני',
        'home.pill.cafe': 'בתי קפה',
        'home.pill.tlv': 'תל אביב',
        'home.pill.jlm': 'ירושלים',
        'home.pill.haifa': 'חיפה',

        // restaurants section
        'home.rest_title': 'מסעדות מובחרות',
        'home.rest_sub': 'מקומות שאורחים אוהבים — פנויים להזמנה היום',
        'home.rest_all': 'כל המסעדות',
        'home.rest_none': 'אין מסעדות בקטגוריה זו — ראו את כל העסקים ב', 
        'home.rest_cta': 'קבעו מקום',

        // B2B band
        'home.b2b_title': 'יש לך מסעדה?',
        'home.b2b_sub': 'HOPpA היא מערכת ההזמנות וההושבה למסעדות — פחות אי-הופעות, יותר שולחנות מלאים, וכל התמונה במסך אחד.',
        'home.step1_title': 'הקמה תוך דקות',
        'home.step1_text': 'פותחים דף עסק, מגדירים שולחנות ושעות פעילות — ומתחילים לקבל הזמנות.',
        'home.step2_title': 'הלקוחות מזמינים לבד',
        'home.step2_text': 'האורחים קובעים מקום אונליין מדף העסק, מזוהים לפי טלפון.',
        'home.step3_title': 'הושבה אוטומטית ותור',
        'home.step3_text': 'כל הזמנה משובצת לשולחן הפנוי המתאים, עם ניהול תור חכם בשעות השיא.',
        'home.b2b_cta': 'התחילו עכשיו',

        // pricing
        'home.pricing_title': 'מחירים',
        'home.pricing_sub': 'בחרו את החבילה שמתאימה לעסק שלכם',
        'home.price_flag': 'הכי פופולרי',
        'home.price_per_month': ' / חודש',
        'home.price_cta': 'בחרו חבילה',
        'home.plan_basic_name': 'בסיסי',
        'home.plan_basic_sub': 'למסעדה קטנה שמתחילה',
        'home.plan_basic_p1': 'הזמנות אונליין',
        'home.plan_basic_p2': 'יומן הזמנות',
        'home.plan_basic_p3': 'זיהוי אורח לפי טלפון',
        'home.plan_basic_p4': 'עד 40 שולחנות',
        'home.plan_pro_name': 'מקצועי',
        'home.plan_pro_sub': 'הכי פופולרי — לעסק פעיל',
        'home.plan_pro_p1': 'כל מה שבבסיסי',
        'home.plan_pro_p2': 'הושבה אוטומטית',
        'home.plan_pro_p3': 'תור חכם ותזכורות SMS',
        'home.plan_pro_p4': 'מפת ישיבה חיה (LIVE)',
        'home.plan_pro_p5': 'דוחות ותובנות',
        'home.plan_chains_name': 'רשתות',
        'home.plan_chains_sub': 'לרשתות ומספר סניפים',
        'home.plan_chains_p1': 'כל מה שבמקצועי',
        'home.plan_chains_p2': 'ריבוי סניפים',
        'home.plan_chains_p3': 'ניהול הרשאות צוות',
        'home.plan_chains_p4': 'תמיכה בעדיפות',

        // FAQ
        'home.faq_title': 'שאלות נפוצות',
        'home.faq_q1': 'כמה זמן לוקח להקים את המערכת?',
        'home.faq_a1': 'ההקמה הבסיסית לוקחת דקות ספורות — פותחים דף עסק, מגדירים שולחנות ושעות, ואפשר להתחיל לקבל הזמנות עוד היום.',
        'home.faq_q2': 'האם הלקוחות שלי צריכים להתקין אפליקציה?',
        'home.faq_a2': 'לא. האורחים מזמינים מקום ישירות מדף העסק בדפדפן, ללא הורדה או הרשמה מסובכת — מזוהים אוטומטית לפי מספר הטלפון.',
        'home.faq_q3': 'איך HOPpA מפחיתה אי-הופעות?',
        'home.faq_a3': 'המערכת שולחת תזכורות אוטומטיות ב-SMS ובמייל, ומאפשרת גביית מקדמות — כך פחות שולחנות נשארים ריקים בשעות השיא.',
        'home.faq_q4': 'אפשר לנהל כמה סניפים מאותו חשבון?',
        'home.faq_a4': 'כן. חבילת "רשתות" נבנתה בדיוק לזה — ריבוי סניפים, הרשאות צוות וניהול מרוכז.',
        'home.faq_q5': 'אפשר לבטל בכל עת?',
        'home.faq_a5': 'בהחלט. אין התחייבות לתקופה — אפשר לשדרג, לרדת חבילה או לבטל מתי שרוצים.',

        // footer
        'home.footer_tagline': 'מערכת ההזמנות וההושבה למסעדות — קבעו מקום בקלות, נהלו את הערב בלי בלגן.',
        'home.footer_diners': 'סועדים',
        'home.footer_discover': 'גילוי מסעדות',
        'home.footer_featured': 'מסעדות מובחרות',
        'home.footer_faq': 'שאלות נפוצות',
        'home.footer_owners': 'לבעלי מסעדות',
        'home.footer_how': 'איך זה עובד',
        'home.footer_login_system': 'כניסה למערכת',
        'home.footer_login': 'התחברות',
        'home.footer_register': 'הרשמה',
        'home.footer_contact': 'צור קשר',
        'home.footer_rights': '© {year} HOPpA · כל הזכויות שמורות',
    },

    en: {
        // ── nav (PublicShell) ──
        'nav.discover': 'Discover',
        'nav.my': 'My reservations',
        'nav.login': 'Log in',
        'nav.langLabel': 'Language',

        // ── common ──
        'common.loading': 'Loading…',
        'common.back_to_discovery': 'Back to discovery',
        'common.today': 'Today',
        'common.tomorrow': 'Tomorrow',

        // ── directory ──
        'directory.brand': 'HOPpA',
        'directory.login': 'Log in',
        'directory.hero_title': 'Discover places',
        'directory.hero_sub': 'All businesses in one place — book a table in a few clicks.',
        'directory.all_businesses': 'All businesses',
        'directory.filter_hint': 'Filter by category or search by name and city.',
        'directory.category_group': 'Category',
        'directory.all': 'All',
        'directory.count_found': '{count} businesses found',
        'directory.clear_filter': 'Clear filters',
        'directory.loading': 'Loading…',
        'directory.error_title': 'Can’t load businesses right now',
        'directory.error_sub': 'Try refreshing the page in a moment.',
        'directory.empty_title': 'No businesses found',
        'directory.empty_sub': 'Try changing your search terms or clearing the filters.',
        'directory.boosted': 'Featured',
        'directory.boosted_aria': 'Featured business',
        'directory.card_cta': 'Book a table',

        // ── search ──
        'search.all_cities': 'All cities',
        'search.pick_city': 'Choose a city',
        'search.city_dialog_aria': 'Choose a city',
        'search.city_close': 'Close',
        'search.city_empty': 'No cities available right now — searching all cities.',
        'search.mode_group': 'Search type',
        'search.mode_book': 'Book a table',
        'search.mode_available': 'By availability',
        'search.time_aria': 'Time',
        'search.date_aria': 'Date',
        'search.party_aria': 'Party size',
        'search.party_one': '1 person',
        'search.party_many': '{count} people',
        'search.submit': 'Find me a place',
        'search.day_sunday': 'Sunday',
        'search.day_monday': 'Monday',
        'search.day_tuesday': 'Tuesday',
        'search.day_wednesday': 'Wednesday',
        'search.day_thursday': 'Thursday',
        'search.day_friday': 'Friday',
        'search.day_saturday': 'Saturday',

        // ── business ──
        'business.loading': 'Loading…',
        'business.not_found': 'Business not found.',
        'business.back': 'Back to restaurants',
        'business.gallery_aria': 'Photo gallery',
        'business.image_alt': 'Photo',
        'business.booking_aria': 'Table booking',
        'business.booking_title': 'Book a table',
        'business.booking_sub': 'Fill in the details in order. Required fields are marked.',
        'business.required': 'required',
        'business.optional': '(optional)',
        'business.phone_label': 'Phone',
        'business.phone_placeholder': '05x-000-0000',
        'business.phone_invalid': 'Invalid phone number',
        'business.name_label': 'Full name',
        'business.name_placeholder': 'Your name',
        'business.party_label': 'Party size',
        'business.diner_one': 'diner',
        'business.diner_many': 'diners',
        'business.dec_aria': 'Fewer',
        'business.inc_aria': 'More',
        'business.date_label': 'Date',
        'business.avail_label': 'Availability & seating area',
        'business.checking_avail': 'Checking availability…',
        'business.oversized_title': 'For a group this size — call to book',
        'business.oversized_sub_phone': 'A group this size can’t be booked online. We’d love to host you — call us and we’ll arrange a spot.',
        'business.oversized_sub_nophone': 'Contact the business to book for a large group.',
        'business.avail_found': 'We found several available spots for you',
        'business.avail_found_sub': 'For {date}{time} for {party} people',
        'business.avail_around': ' around {time}',
        'business.instant_confirm': 'Instant confirmation',
        'business.closed': 'Closed',
        'business.no_hours_today': 'No opening hours on this day — pick another date.',
        'business.no_avail_today': 'No availability on this day — try another date or party size.',
        'business.notes_label': 'Notes',
        'business.marketing_consent': 'I would like to receive updates and offers from this business (optional)',
        'business.notes_placeholder': 'Allergies, special request, birthday…',
        'business.summary_diners': 'diners',
        'business.submitting': 'Sending…',
        'business.submit': 'Confirm booking',
        'business.hint_phone': 'Enter a valid phone number to continue',
        'business.hint_name': 'Add a full name',
        'business.hint_slot_area': 'Choose an available time and area',
        'business.hint_slot': 'Choose a time',
        'business.success_title': 'Booking received!',
        'business.success_sub': 'Your booking was sent to the restaurant and will appear in their system. We’ll contact you for final confirmation.',
        'business.manage_prompt': 'To view or cancel the booking:',
        'business.manage_link': 'Manage booking',
        'business.another_booking': 'Another booking',
        'business.about_aria': 'About',
        'business.about_title': 'About',
        'business.menu_aria': 'Menu',
        'business.menu_title': 'Menu',
        'business.hours_aria': 'Opening hours',
        'business.hours_title': 'Opening hours',
        'business.hours_today_suffix': ' · Today',
        'business.location_aria': 'Location',
        'business.location_title': 'Location',
        'business.rate_limited': 'A similar booking already exists or too many attempts were made. Please try again later.',
        'business.booking_failed': 'The booking failed — the time may be too close to closing or the group too large. Try another time or call.',

        // ── manage ──
        'manage.loading': 'Loading…',
        'manage.invalid_title': 'The link is invalid',
        'manage.invalid_sub': 'The link is invalid or the reservation was not found.',
        'manage.default_biz': 'Your reservation',
        'manage.title': 'Your reservation',
        'manage.status_confirmed': 'Confirmed',
        'manage.status_cancelled': 'Cancelled',
        'manage.diners': 'diners',
        'manage.cancelled_note': 'The reservation was cancelled.',
        'manage.confirm_cancel': 'Cancel the reservation? This action can’t be undone.',
        'manage.cancel_failed': 'Cancelling the reservation failed. Try again or contact the business.',
        'manage.cancelling': 'Cancelling…',
        'manage.cancel_btn': 'Cancel reservation',
        'manage.reschedule_note': 'To change the date — contact the business.',
        'manage.to_business_page': 'To the business page',

        // ── my ──
        'my.status_arrived': 'Arrived',
        'my.status_seated': 'Seated',
        'my.status_confirmed': 'Confirmed',
        'my.title': 'My reservations',
        'my.phone_sub': 'Enter the phone number you booked with — we’ll send you a one-time code by SMS.',
        'my.phone_placeholder': '050-0000000',
        'my.phone_aria': 'Phone number',
        'my.phone_invalid': 'Enter a valid phone number',
        'my.send_failed': 'We couldn’t send a code, please try again',
        'my.sending': 'Sending…',
        'my.send_code': 'Send code',
        'my.code_title': 'Enter the code',
        'my.code_sub': 'We sent a code to {phone} (if there are reservations for this number).',
        'my.code_placeholder': '●●●●●●',
        'my.code_aria': 'One-time code',
        'my.code_missing': 'Enter the code you received',
        'my.code_invalid': 'Wrong or expired code',
        'my.checking': 'Checking…',
        'my.view_reservations': 'View reservations',
        'my.change_number': 'Change number',
        'my.future_title': 'Your upcoming reservations',
        'my.none': 'You have no upcoming reservations.',
        'my.discover': 'Discover',
        'my.default_biz': 'The business',
        'my.diners': 'diners',
        'my.confirm_cancel': 'Cancel the reservation? This action can’t be undone.',
        'my.cancel_failed': 'Cancelling the reservation failed. Try again or contact the business.',
        'my.cancelling': 'Cancelling…',
        'my.cancel': 'Cancel',
        'my.details': 'Details',

        // ── home (MarketingHome / /welcome) ──
        'home.brand_aria': 'HOPpA',
        'home.nav.restaurants': 'Restaurants',
        'home.nav.how': 'How it works',
        'home.nav.pricing': 'Pricing',
        'home.nav.faq': 'FAQ',
        'home.search_placeholder': 'Search a restaurant, cuisine or city…',
        'home.search_aria': 'Search',
        'home.menu_aria': 'Menu',
        'home.login': 'Log in',
        'home.register': 'Sign up',

        // hero
        'home.hero_title': 'Book a table at the most sought-after restaurants',
        'home.hero_sub': 'Discover restaurants available today and reserve a table in a few clicks.',

        // mosaic cards
        'home.book_at': 'Book a table at {name}',
        'home.badge_today': 'Available today',

        // promo
        'home.promo_tag': 'Featured',
        'home.promo_title': 'Friday night out?',
        'home.promo_text': 'The most sought-after restaurants fill up fast — grab a table now.',
        'home.promo_cta': 'Discover all',

        // filter pills
        'home.filter_aria': 'Filter',
        'home.pill.all': 'All',
        'home.pill.chef': 'Chef restaurants',
        'home.pill.grill': 'Meat · Grill',
        'home.pill.fish': 'Fish & seafood',
        'home.pill.italian': 'Italian',
        'home.pill.asian': 'Asian',
        'home.pill.mediterranean': 'Mediterranean',
        'home.pill.vegan': 'Vegan',
        'home.pill.cafe': 'Cafés',
        'home.pill.tlv': 'Tel Aviv',
        'home.pill.jlm': 'Jerusalem',
        'home.pill.haifa': 'Haifa',

        // restaurants section
        'home.rest_title': 'Featured restaurants',
        'home.rest_sub': 'Places guests love — available to book today',
        'home.rest_all': 'All restaurants',
        'home.rest_none': 'No restaurants in this category — see all businesses in', 
        'home.rest_cta': 'Book a table',

        // B2B band
        'home.b2b_title': 'Own a restaurant?',
        'home.b2b_sub': 'HOPpA is the reservations and seating system for restaurants — fewer no-shows, more full tables, and the whole picture on one screen.',
        'home.step1_title': 'Set up in minutes',
        'home.step1_text': 'Open a business page, define your tables and opening hours — and start taking reservations.',
        'home.step2_title': 'Guests book themselves',
        'home.step2_text': 'Guests reserve online from your business page, identified by phone.',
        'home.step3_title': 'Automatic seating & queue',
        'home.step3_text': 'Every reservation is assigned to the right open table, with smart queue management at peak hours.',
        'home.b2b_cta': 'Get started',

        // pricing
        'home.pricing_title': 'Pricing',
        'home.pricing_sub': 'Choose the plan that fits your business',
        'home.price_flag': 'Most popular',
        'home.price_per_month': ' / month',
        'home.price_cta': 'Choose plan',
        'home.plan_basic_name': 'Basic',
        'home.plan_basic_sub': 'For a small restaurant getting started',
        'home.plan_basic_p1': 'Online reservations',
        'home.plan_basic_p2': 'Reservations calendar',
        'home.plan_basic_p3': 'Guest identification by phone',
        'home.plan_basic_p4': 'Up to 40 tables',
        'home.plan_pro_name': 'Professional',
        'home.plan_pro_sub': 'Most popular — for an active business',
        'home.plan_pro_p1': 'Everything in Basic',
        'home.plan_pro_p2': 'Automatic seating',
        'home.plan_pro_p3': 'Smart queue & SMS reminders',
        'home.plan_pro_p4': 'Live seating map (LIVE)',
        'home.plan_pro_p5': 'Reports & insights',
        'home.plan_chains_name': 'Chains',
        'home.plan_chains_sub': 'For chains and multiple branches',
        'home.plan_chains_p1': 'Everything in Professional',
        'home.plan_chains_p2': 'Multiple branches',
        'home.plan_chains_p3': 'Staff permission management',
        'home.plan_chains_p4': 'Priority support',

        // FAQ
        'home.faq_title': 'Frequently asked questions',
        'home.faq_q1': 'How long does it take to set up the system?',
        'home.faq_a1': 'The basic setup takes just a few minutes — open a business page, define tables and hours, and you can start taking reservations today.',
        'home.faq_q2': 'Do my customers need to install an app?',
        'home.faq_a2': 'No. Guests book directly from your business page in the browser, with no download or complicated sign-up — they’re identified automatically by phone number.',
        'home.faq_q3': 'How does HOPpA reduce no-shows?',
        'home.faq_a3': 'The system sends automatic reminders by SMS and email, and lets you collect deposits — so fewer tables sit empty during peak hours.',
        'home.faq_q4': 'Can I manage several branches from one account?',
        'home.faq_a4': 'Yes. The "Chains" plan was built exactly for that — multiple branches, staff permissions and centralized management.',
        'home.faq_q5': 'Can I cancel anytime?',
        'home.faq_a5': 'Absolutely. There’s no long-term commitment — you can upgrade, downgrade or cancel whenever you want.',

        // footer
        'home.footer_tagline': 'The reservations and seating system for restaurants — book a table easily, run your evening without the chaos.',
        'home.footer_diners': 'Diners',
        'home.footer_discover': 'Discover restaurants',
        'home.footer_featured': 'Featured restaurants',
        'home.footer_faq': 'FAQ',
        'home.footer_owners': 'For restaurant owners',
        'home.footer_how': 'How it works',
        'home.footer_login_system': 'System login',
        'home.footer_login': 'Log in',
        'home.footer_register': 'Sign up',
        'home.footer_contact': 'Contact us',
        'home.footer_rights': '© {year} HOPpA · All rights reserved',
    },
};

export default translations;
